const API = process.env.REACT_APP_BACKEND_URL + '/api';

// Generate or retrieve a persistent anonymous visitor ID
const getVisitorId = () => {
  let vid = localStorage.getItem('findadz_vid');
  if (!vid) {
    vid = 'v_' + Math.random().toString(36).substring(2) + Date.now().toString(36);
    localStorage.setItem('findadz_vid', vid);
  }
  return vid;
};

export const trackPageView = (page, listingId = null) => {
  const token = localStorage.getItem('token');
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  fetch(`${API}/analytics/track`, {
    method: 'POST',
    headers,
    body: JSON.stringify({
      page,
      listing_id: listingId,
      visitor_id: getVisitorId(),
      referrer: document.referrer || null
    })
  }).catch(() => {}); // fire and forget
};
